<template>
    <div class="app-container">
        <div class="filter-container">
            <el-input class="filter-item" v-model="listQuery.querymodel.keyword" placeholder="车牌号" style="width: 200px"
                @keyup.enter.native="getList()" />
            <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
        </div>
        <el-table class="app-table" :data="list" border fit highlight-current-row stripe style="width: 100%"
            :height="getViewHeight()" :header-cell-style="{ background: '#F3F4F7', color: '#555' }"
            :row-style="{ height: '10px' }" :cell-style="{ padding: '7px 0' }">
            <el-table-column label="序号" width="100" align="center" type="index">
            </el-table-column>
            <el-table-column label="道闸名称" align="center">
                <template slot-scope="{ row }">
                    <span>{{ row.BarrierGateName }}</span>
                </template>
            </el-table-column>
            <el-table-column label="道闸SN" align="center">
                <template slot-scope="{ row }">
                    <span>{{ row.BarrierGateSn }}</span>
                </template>
            </el-table-column>
            <el-table-column label="道闸类型" align="center">
                <template slot-scope="{ row }">
                    <span>{{ row.BarrierGateTypeName }}</span>
                </template>
            </el-table-column>
            <el-table-column label="所属路段" align="center">
                <template slot-scope="{ row }">
                    <span>{{ row.SectionName }}</span>
                </template>
            </el-table-column>
            <el-table-column label="无牌车扫码出入场二维码" align="center">
                <template slot-scope="{ row }">
                    <div v-if="row.BarrierGateCode" class="newCode" :id="'qrcode_' + row.BarrierGateCode"
                        @click="createCode(row.BarrierGateCode, true, row.BarrierGateName, row)">
                        <canvas :id="'canvas_' + row.BarrierGateCode" v-if="row.BarrierGateCode"></canvas>
                    </div>
                </template>
            </el-table-column>
            <el-table-column :min-width="200" label="操作" align="center">
                <template slot-scope="{ row }">
                    <el-button type="primary" size="mini" icon="el-icon-edit" v-if="authedit" @click="edit(row)">
                        编辑
                    </el-button>
                    <el-button v-if="authdelete" icon="el-icon-delete" size="mini" type="danger" @click="deleted(row)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageIndex" :limit.sync="listQuery.pageSize"
            @pagination="getList" />
        <el-dialog :title="codeTitle" :visible.sync="codeShow" show-close width="350px"
            class-name="vertical-center-modal">
            <div class="codeModal" id="qrcode">
                <canvas id="canvas"></canvas>
            </div>
            <div class="codeBtns">
                <div @click="downCode">下载二维码</div>
            </div>
        </el-dialog>
        <addbarriergate v-if="dialogshow" :dialogshow="dialogshow" :isedit="isedit" :editform="editform"
            :sectionlist="sectionlist" @savecomplete="savecomplete" @cancelcomplete="cancelcomplete"></addbarriergate>
    </div>
</template>
<style scoped>
.getCode {
    color: #398af1;
    cursor: pointer;
}

.newCode {
    align-self: center;
    /*width: 30px;*/
    /*height: 50px;*/
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    cursor: pointer;
}

.codeModal {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
}

.codeBtns {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    color: #398af1;
    font-size: 15px;
    margin-bottom: 20px;
}

.codeBtns>div {
    cursor: pointer;
}

.codeBtns>div:hover {
    opacity: 0.8;
}
</style>
<script>
import { querybarriergatelist, deletebarriergate } from "@/api/barriergate";
import { query as querysectionlist } from "@/api/section";
import waves from "@/directive/waves"; // waves directive
import { getButtonList } from "../../promissionRouter";
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import Toolbar from "../../components/Toolbar";
import addbarriergate from "./components/addbarriergate.vue";
import QRCode from "qrcode";
export default {
    components: { Pagination, Toolbar, addbarriergate },
    directives: { waves },
    data() {
        return {
            codeTitle: "",
            codeShow: false,
            codeInfo: {},
            sectionlist: [],
            dialogshow: false,
            isedit: false,
            buttonList: [],
            list: null,
            pageIndex: 1,
            total: 0,
            isedit: false,
            authedit: false,
            authdelete: false,
            editform: {
                Id: 0,
                BarrierGateName: "",
                BarrierGateSn: "",
                BarrierGateBrand: "",
                BarrierGateType: 0,
                SectionId: 0,
                BarrierGateState: true
            },
            listQuery: {
                pageIndex: 1,
                pageSize: 15,
                orderColumn: "",
                orderbyasc: false,
                querymodel: {
                    keyword: "",
                },
            },
        };
    },
    created() {
        querysectionlist({
            pageSize: 10000,
            querymodel: {
                keyword: "",
                BarrierGateMode: 1
            }
        }).then((res) => {
            this.sectionlist = res.data;
        });
        this.getList();
    },
    methods: {
        callFunction(item) {
            this[item.BtnCode].apply(this, item);
        },
        create() {
            this.isedit = false;
            this.editform = {};
            this.editform.EnableMark=true;
            this.dialogshow = true;
        },
        edit(row) {
            this.isedit = true;
            this.dialogshow = true;
            this.editform = row;
        },
        savecomplete(item) {
            this.dialogshow = false;
            this.getList();
        },
        cancelcomplete() {
            this.dialogshow = false;
        },
        deleted(row) {
            this.$confirm("确定删除吗?", "提示", {
                type: "warning",
            }).then(() => {
                deletebarriergate({ id: row.Id }).then((res) => {
                    this.$message({
                        message: "删除成功！",
                        type: "success",
                    });
                    this.$bus.$emit("msgsent", "addunit");
                    this.getList();
                });
            });
        },
        getList(item) {
            if (item != null && item != undefined) {
                this.listQuery.pageIndex = item.page;
                this.listQuery.pageSize = item.limit;
            } else {
                this.listQuery.pageIndex = 1;
            }
            querybarriergatelist(this.listQuery).then((res) => {
                this.list = res.data;
                this.total = res.dataCount;
                setTimeout(() => {
                    this.list.forEach((item) => {
                        if (item.BarrierGateCode) {
                            this.createCode(item.BarrierGateCode);
                        }
                    });
                }, 300);
            });
        },
        createCode(BarrierGateCode, show, name, row) {
            if (!show) {
                var canvas = document.getElementById("canvas_" + BarrierGateCode);
                QRCode.toCanvas(canvas, BarrierGateCode, { width: 50 }, function (error) {
                    if (error) console.error(error);
                });
            } else {
                this.codeInfo = row;
                this.codeInfo.BarrierGateCode = BarrierGateCode;
                this.codeTitle = `${name}的扫码出入场二维码`;
                this.codeShow = show;
                setTimeout(() => {
                    var canvas = document.getElementById("canvas");
                    QRCode.toCanvas(
                        canvas,
                        BarrierGateCode,
                        { width: 300 },
                        function (error) {
                            if (error) console.error(error);
                        }
                    );
                }, 100);
            }
        },
        refCode(id) {
            gettablecode({ id: this.codeInfo.Id || id }).then((res) => {
                this.createCode(res, true, this.codeInfo.TableName, this.codeInfo);
                // setTimeout(() => {
                //   this.createCode(res);
                // }, 1000);
            });
        },
        downCode() {
            var canvas = document.getElementById("canvas");
            var a = document.createElement("a");
            a.href = canvas.toDataURL();
            a.download = `${this.codeTitle}`;
            a.click();
        }
    },
    mounted() {
        let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
        this.buttonList = getButtonList(this.$route.path, routers);
        this.buttonList.forEach((item) => {
            if (item.BtnCode === "delete") {
                this.authdelete = true;
            }
            if (item.BtnCode === "edit") {
                this.authedit = true;
            }
        });
    },
};
</script>